import { render, staticRenderFns } from "./file-result.vue?vue&type=template&id=194e7e8d&scoped=true&"
import script from "./file-result.vue?vue&type=script&lang=js&"
export * from "./file-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194e7e8d",
  null
  
)

export default component.exports